import { logVerboseUsage } from 'owa-analytics';
import type { LayoutChangeSource } from 'owa-layout';

export default async function logFolderPaneState(
    layoutChangeSource: LayoutChangeSource,
    folderPaneNewShowState: boolean,
    folderPaneOldShowState: boolean
): Promise<void> {
    /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
     * BASELINE: DO NOT COPY/PASTE!
     *	> Argument at index 1 for logVerboseUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
    logVerboseUsage('TnS_FolderPaneChange', undefined, [
        layoutChangeSource.toString(),
        folderPaneNewShowState,
        folderPaneOldShowState,
    ]);
}
